import { createAction } from 'redux-act';
import { UserType } from 'modules/types';

export const signInRequestSaga: any = createAction('signInRequestSaga');
export const signOut: any = createAction('signOut');
export const loginByTokenSaga: any = createAction('loginByTokenSaga');
export const setProfile: any = createAction('setProfile', (profile: UserType) => ({ profile }));
export const getProductTagsSaga: any = createAction('getProductTagsSaga');
export const setProductTags: any = createAction('setProductTags', (tags: any) => ({ tags }));
